module.exports = __webpack_public_path__ + "static/media/ru.bb7459ed.webp";